var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("FeathersAutocomplete", {
        attrs: {
          label: "Node",
          "service-name": _vm.serviceName,
          "item-text": _vm.itemText,
          limit: 100,
          params: _vm.params,
          "return-object": "",
        },
        on: {
          change: function ($event) {
            return _vm.$emit("change")
          },
          loadMore: _vm.loadMoreSearch,
          serviceError: _vm.displaySnackbarError,
        },
        scopedSlots: _vm._u([
          {
            key: "append-outer",
            fn: function () {
              return [
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "600" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var dialogOn = ref.on
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var tooltipOn = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              { attrs: { icon: "" } },
                                              Object.assign(
                                                {},
                                                tooltipOn,
                                                dialogOn
                                              )
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-magnify"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Search node")])]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.searchDialog,
                      callback: function ($$v) {
                        _vm.searchDialog = $$v
                      },
                      expression: "searchDialog",
                    },
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [_vm._v(" Search a node ")]),
                        _c(
                          "v-card-text",
                          [
                            _c("v-text-field", {
                              attrs: {
                                dense: _vm.dense,
                                label: "Node Name",
                                disabled: _vm.disableNameSearch,
                                hint: "Case sensitive",
                              },
                              model: {
                                value: _vm.nodeNameSearch,
                                callback: function ($$v) {
                                  _vm.nodeNameSearch = $$v
                                },
                                expression: "nodeNameSearch",
                              },
                            }),
                            _c("v-text-field", {
                              attrs: {
                                dense: _vm.dense,
                                label: "Node ID",
                                disabled: _vm.disableIdSearch,
                              },
                              model: {
                                value: _vm.nodeIdSearch,
                                callback: function ($$v) {
                                  _vm.nodeIdSearch = $$v
                                },
                                expression: "nodeIdSearch",
                              },
                            }),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  outlined: "",
                                  block: "",
                                  rounded: "",
                                  color: "primary",
                                  loading: _vm.dataLoading,
                                },
                                on: { click: _vm.searchNode },
                              },
                              [
                                _c("v-icon", [_vm._v("mdi-magnify")]),
                                _vm._v(" search "),
                              ],
                              1
                            ),
                            _vm.result.length
                              ? [
                                  _c("v-divider", { staticClass: "my-2" }),
                                  _c("v-data-table", {
                                    attrs: {
                                      items: _vm.result,
                                      headers: _vm.resultTableHeaders,
                                      "item-key": _vm.itemKey,
                                      dense: "",
                                      "hide-default-footer": "",
                                      "single-select": "",
                                    },
                                    on: { "click:row": _vm.rowClick },
                                    model: {
                                      value: _vm.resultSelected,
                                      callback: function ($$v) {
                                        _vm.resultSelected = $$v
                                      },
                                      expression: "resultSelected",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  outlined: "",
                                  rounded: "",
                                  color: "primary",
                                  disabled: !_vm.resultSelected.length,
                                },
                                on: { click: _vm.setNode },
                              },
                              [_vm._v(" open ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.computedValue,
          callback: function ($$v) {
            _vm.computedValue = $$v
          },
          expression: "computedValue",
        },
      }),
      _c(
        "v-snackbar",
        {
          attrs: {
            app: "",
            right: "",
            color: _vm.snackbarInfo.color,
            timeout: "8000",
          },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarInfo.message) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "white", dark: "", icon: "", small: "" },
              on: {
                click: function ($event) {
                  _vm.snackbar = false
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }